import { BaseIdNotRequiredRequest } from "../../../../base/request/BaseIdNotRequiredRequest";
import { TareaResponse } from "../response/TareaResponse";

/** Request de creación/edición de una tarea de rastro (`POST
 *  configuracion/tareas/save`). `id` null = crear, con valor = editar. Siempre
 *  asociada a `clienteId` — este endpoint no crea ni convierte tareas
 *  globales. */
export type TareaRequest = BaseIdNotRequiredRequest & {
  /** Cliente dueño de la tarea. */
  clienteId: string;
  /** Nombre de la tarea (único entre las activas del mismo cliente). */
  nombre: string;
};

export const fx_createTareaRequestEmpty = (clienteId: string): TareaRequest => {
  return {
    id: null,
    clienteId,
    nombre: "",
  };
};

export const fx_createTareaRequest = (tarea: TareaResponse): TareaRequest => {
  return {
    id: tarea.id,
    clienteId: tarea.clienteId ?? "",
    nombre: tarea.nombre,
  };
};
